import {Vue} from 'ui.vue';

Vue.component("CitrusPagination", {
	template: `
		<div class="b-container__footer b-container__footer_center">
			<div class="b-switch citrus-pagination" v-if="parameters.showPagination" :class="blockClass">
				<a v-if="hasPrev" class="b-switch__btn b-switch__btn_prev" :href="getPageUrl(null, prevPage)"
				   @click="changePage(prevPage, $event)">
					<slot name="arrow-prev">
						<svg><use xlink:href="/local/templates/mstars/app/assets/dist/icons/sprite.svg#icons--arrow_right"/></svg>
					</slot>
				</a>
				<span v-else class="b-switch__btn b-switch__btn_prev b-switch__btn_disabled">
					<slot name="arrow-prev">
						<svg><use xlink:href="/local/templates/mstars/app/assets/dist/icons/sprite.svg#icons--arrow_right"/></svg>
					</slot>
				</span>

				<a v-if="hasFirst" class="b-switch__item" :href="getPageUrl(null, 1)" @click="changePage(1, $event)">1</a>
				<span v-if="hasAfterFirst" class="b-switch__item b-switch__item_dots">...</span>

				<a v-for="page in pages" :class="{'b-switch__item_active': currentPage == page}" class="b-switch__item"
				   :href="getPageUrl(null, page)" @click="changePage(page, $event)" v-html="page.toString().padStart(2, '0')"></a>

				<span v-if="hasBeforeLast" class="b-switch__item b-switch__item_dots">...</span>

				<a class="b-switch__item" v-if="hasLast" :href="getPageUrl(null, parameters.pagesCount)"
				   @click="changePage(parameters.pagesCount, $event)" v-html="parameters.pagesCount"></a>

				<a v-if="hasNext" class="b-switch__btn b-switch__btn_next"
				   @click="changePage(nextPage, $event)"
				   :href="getPageUrl(null, nextPage)">
					<slot name="arrow-next">
						<svg><use xlink:href="/local/templates/mstars/app/assets/dist/icons/sprite.svg#icons--arrow_right"/></svg>
					</slot>
				</a>
				<span v-else class="b-switch__btn b-switch__btn_next b-switch__btn_disabled">
					<slot name="arrow-next">
						<svg><use xlink:href="/local/templates/mstars/app/assets/dist/icons/sprite.svg#icons--arrow_right"/></svg>
					</slot>
				</span>
			</div>
			<a v-if="!ajaxDisable && parameters.showMoreBtn && currentPage != parameters.pagesCount"
			   href="javascript:void(0)"
			   class="b-btn b-btn_primary b-action__btn"
			   :class="{loading: load.start === true}"
			   @click="showMore()"
			   v-html="localize.CITRUS_VUE_PAGINATION_LOAD_MORE"
			></a>
		</div>
	`,
	props: {
		params: Object,
		load: {
			type: Object,
			required: false,
			default: () => {
				return {
					start: false,
					pageNumber: 1,
					isMoreLink: false
				};
			}
		},
		blockClass: {
			type: [String, Boolean, null],
			required: false,
			default: 'citrus-pagination'
		},
		ajaxDisable: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			parameters: {},
			currentPage: !this.params.hasOwnProperty('currentPage') ? 1 : parseInt(this.params.currentPage)
		};
	},
	created: function () {
		this.initPagination();
	},
	computed: {
		/**
		 * Показывать кнопку `Вперед`
		 *
		 * @returns {boolean}
		 */
		hasNext: function () {
			return !(this.parameters.showNextPrev !== true || this.currentPage >= this.parameters.pagesCount);
		},

		/**
		 * Показывать кнопку `Назад`
		 *
		 * @returns {boolean}
		 */
		hasPrev: function () {
			return (this.currentPage > 1 && this.parameters['showNextPrev'] === true);
		},

		/**
		 *
		 *
		 * @returns {boolean}
		 */
		hasFirst: function () {
			return this.rangeStart !== 1;
		},

		/**
		 *
		 * @returns {boolean}
		 */
		hasLast: function () {
			return this.rangeEnd < this.parameters['pagesCount'];
		},

		/**
		 *
		 * @returns {boolean}
		 */
		hasAfterFirst: function () {
			return this.rangeStart > 2;
		},

		/**
		 *
		 * @returns {boolean}
		 */
		hasBeforeLast: function () {
			return this.rangeEnd < (this.parameters['pagesCount'] - 1);
		},

		/**
		 * Языковые фразы
		 *
		 * @returns {ReadonlyArray<any>}
		 */
		localize() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PAGINATION_");
		},

		/**
		 * Начало подгрузки
		 *
		 * @returns {number}
		 */
		rangeStart: function () {
			let start = this.currentPage - this.parameters['pageRange'];
			return (start > 0) ? start : 1;
		},

		/**
		 * Конец подгрузки
		 *
		 * @returns {*}
		 */
		rangeEnd: function () {
			let end = this.currentPage + this.parameters['pageRange'];
			return (end < this.parameters['pagesCount']) ? end : this.parameters['pagesCount'];
		},

		/**
		 * Массив страниц
		 *
		 * @returns {Array}
		 */
		pages: function () {
			let pages = [];
			for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
				pages.push(i);
			}
			return pages;
		},

		/**
		 * Следующая страница
		 *
		 * @returns {*}
		 */
		nextPage: function () {
			return this.currentPage + 1;
		},

		/**
		 * Предыдущая страница
		 *
		 * @returns {number}
		 */
		prevPage: function () {
			return this.currentPage - 1;
		},

		/**
		 * Текст `Всего элементов`
		 *
		 * @returns {*}
		 */
		totalElementsText() {
			let text = this.params.hasOwnProperty('totalElementsText')
				? this.params.totalElementsText
				: this.localize.CITRUS_VUE_PAGINATION_DEFAULT_TOTAL_ELEMENTS
			;

			return text.replace('#COUNT#', this.parameters['recordCount']);
		},
	},
	watch: {
		params: {
			handler() {
				this.initPagination();
			},
			deep: true
		},
		load: {
			handler() {
				this.currentPage = parseInt(this.load['pageNumber']);
				let params = {};
				params[this.parameters['pageParam']] = "page-" + this.currentPage;
			},
			deep: true
		},
	},
	methods: {

		initPagination: function () {
			let defaultUrl = document.location.href.split("#")[0];
			/**
			 * showPagination - показывать кнопки переключения страниц
			 * showMoreBtn - показывать кнопку `Показать ещё`
			 * showNextPrev - показывать кнопки `вперед` и `назад`
			 * pagesCount - всего страниц
			 * pageRange - сколько `кругляшков` страниц показывать справа и слева от текущего
			 * recordCount - всего записей
			 * pageParam - $_GET параметр, отвечающий за номер страницы
			 * url - адрес текущей страницы
			 * ajaxUrl-  адрес ajax обработчика
			 *
			 * @type {Object} this.parameters
			 */
			this.parameters = {
				'changeHistory': !!(this.params.hasOwnProperty('changeHistory') && true === this.params.changeHistory),
				'showPagination': !!(this.params.hasOwnProperty('showPagination') && true === this.params.showPagination),
				'showMoreBtn': !!(this.params.hasOwnProperty('showMoreBtn') && true === this.params.showMoreBtn),
				'showNextPrev': !!(this.params.hasOwnProperty('showNextPrev') && true === this.params.showNextPrev),
				'pagesCount': this.params.hasOwnProperty('pagesCount') ? this.params['pagesCount'] : 1,
				'pageRange': this.params.hasOwnProperty('pageRange') ? this.params['pageRange'] : 2,
				'recordCount': this.params.hasOwnProperty('recordCount') ? this.params['recordCount'] : 1,
				'pageParam': this.params.hasOwnProperty('pageParam') ? this.params['pageParam'] : 'PAGEN_1',
				'url': this.params.hasOwnProperty('url') ? this.params['url'] : defaultUrl,
				'ajaxUrl': this.params.hasOwnProperty('ajaxUrl')
					? this.params['ajaxUrl']
					: (this.params.hasOwnProperty('url') ? this.params['url'] : defaultUrl)
			};
			this.parameters['url'] = BX.util.remove_url_param(this.parameters['url'], this.parameters['pageParam']);
			this.parameters['ajaxUrl'] = BX.util.remove_url_param(this.parameters['ajaxUrl'], this.parameters['pageParam']);
			this.parameters['ajaxUrl'] = BX.util.add_url_param(this.parameters['ajaxUrl'], {
				'is_ajax': 'Y',
			});

			this.currentPage = !this.params.hasOwnProperty('currentPage') ? 1 : parseInt(this.params.currentPage);
		},

		/**
		 * Заголовок страницы при изменении номера страницы
		 * TODO: Используется при клонировании компонента!
		 *
		 * @param pageNumber
		 * @returns {null, string}
		 */
		getPageTitle: function () {
			return null;
		},

		/**
		 * Генерация ссылки окна браузера для пагинации
		 *
		 * @param type
		 * @param pageNumber
		 * @returns {*}
		 */
		getPageUrl: function (type, pageNumber) {
			let data = {};
			if (typeof type === 'string') {
				data[type] = 'Y';
			}
			data[this.parameters['pageParam']] = (typeof pageNumber === 'number')
				? pageNumber
				: this.currentPage;

			return BX.util.add_url_param(document.location.href.split("#")[0], data);
		},


		/**
		 * Подгрузка элементов через кнопку `Показать ещё`
		 */
		showMore: function () {
			if (this.ajaxDisable || this.load['start']) {
				return false;
			}

			let pageNumber = this.currentPage + 1,
				url = this.getPageUrl('show_more', pageNumber);

			this.$emit('page-changed', {
				pageNumber: pageNumber,
				isMoreLink: true,
				pageParam: this.parameters.pageParam
			});

			if (this.parameters.changeHistory) {
				window.history.pushState({route: url}, this.getPageTitle(pageNumber), url);
			}

			BX.onCustomEvent('Citrus.PageNavigation.Changed', [pageNumber, true, this.parameters.pageParam]);
		},

		/**
		 * Изменение страницы через стандартный переключатель
		 * @param pageNumber
		 */
		changePage: function (pageNumber, event) {
			if (this.ajaxDisable) {
				return;
			}

			if (event) {
				event.preventDefault();
			}

			pageNumber = typeof pageNumber !== 'number' ? parseInt(this.currentPage) : parseInt(pageNumber);

			let url = this.getPageUrl('change_page', pageNumber);
			this.$emit('page-changed', {
				pageNumber: pageNumber,
				isMoreLink: false,
				pageParam: this.parameters.pageParam
			});

			if (this.parameters.changeHistory) {
				window.history.pushState({route: url}, this.getPageTitle(pageNumber), url);
			}

			BX.onCustomEvent('Citrus.PageNavigation.Changed', [pageNumber, false, this.parameters.pageParam]);
		}
	}
});
